/**
 * Students and new grads sub page
 * In the future these subpages will be automatically generated through gatsby-node.js
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import Layout from 'components/Layout'
import ContentfulSubPage from 'components/contentful/ContentfulSubPage'
import { graphql, useStaticQuery } from 'gatsby'
import styles from './StudentsNewGrads.module.scss'

const StudentsNewGrads = (props) => {
  const data = useStaticQuery(graphql`
    query {
      contentfulSubPage(slug: { eq: "students-new-grads" }) {
        ...SubPageFragment
      }
    }
  `)

  const studentsNewGradsPage = data?.contentfulSubPage || {}
  const { title, backgroundColor, content } = studentsNewGradsPage

  return (
    <Layout
      {...props}
      {...studentsNewGradsPage}
      rootPath="/careers">
      <ContentfulSubPage
        className={styles.subpageContainer}
        title={title}
        backgroundColor={backgroundColor}
        content={content} />
    </Layout>
  )
}

export default StudentsNewGrads
